module.exports = __webpack_public_path__ + "static/media/wd4.2fdc0250.jpeg";